import { Component, OnInit } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { EntityType } from 'src/app/model/Enums';

@Component({
  selector: 'app-ist-help-pupup',
  templateUrl: './ist-help-pupup.component.html',
  styleUrls: ['./ist-help-pupup.component.scss']
})
export class ISTHelpPupupComponent implements OnInit {

  helpImageSrc: string = '';
  helpInstruction: string = '';
  activeBtn: number = 0;

  defaultOpenOption: EntityType = null;

  constructor(public bsModalRef: BsModalRef) { }

  ngOnInit(): void {
    switch (this.defaultOpenOption) {
      case EntityType.FORM_1120S:
        this.showHelpDetails(1);
        break;
      case EntityType.FORM_1120:
        this.showHelpDetails(7);
        break;
      case EntityType.FORM_1065:
        this.showHelpDetails(13);
        break;
      case EntityType.SCHEDULE_C:
        this.showHelpDetails(20);
        break;
      default:
        this.showHelpDetails(0);
        break;
    }
  }

  showHelpDetails(activeOption: number) {
    switch (activeOption) {
      // 1120s
      case 1:
        this.helpImageSrc = '../../../../../assets/incomeHelpImages/1120S/revenue.png';
        this.helpInstruction = 'Revenue on the Federal Tax Return Form 1120S can be found on Page 1 of the form under Line 1a.';
        this.activeBtn = 1;
        break;
      case 2:
        this.helpImageSrc = '../../../../../assets/incomeHelpImages/1120S/profit_before_taxes.png';
        this.helpInstruction = 'Profit before Taxes on the Federal Tax Return Form 1120S can be found on Page 1 of the form under Line 21.';
        this.activeBtn = 2;
        break;
      case 3:
        this.helpImageSrc = '../../../../../assets/incomeHelpImages/1120S/interest.png';
        this.helpInstruction = 'Interest on the Federal Tax Return Form 1120S can be found on Page 1 of the form under Line 13.';
        this.activeBtn = 3;
        break;
      case 4:
        this.helpImageSrc = '../../../../../assets/incomeHelpImages/1120S/depreciation.png';
        this.helpInstruction = 'Depreciation on the Federal Tax Return Form 1120S can be found on Page 1 of the form under Line 14.';
        this.activeBtn = 4;
        break;
      case 5:
        this.helpImageSrc = '../../../../../assets/incomeHelpImages/1120S/amortization.png';
        this.helpInstruction = 'Amortization on the Federal Tax Return Form 1120S can be found in a separate Statement.';
        this.activeBtn = 5;
        break;
      case 6:
        this.helpImageSrc = '../../../../../assets/incomeHelpImages/1120S/owners_comp.png';
        this.helpInstruction = 'All Owner(s)’s Compensation on the Federal Tax Return Form 1120S can be found on Page 1 of the form under Line 7.';
        this.activeBtn = 6;
        break;

      // 1120
      case 7:
        this.helpImageSrc = '../../../../../assets/incomeHelpImages/1120/revenue.png';
        this.helpInstruction = 'Revenue on the Federal Tax Return Form 1120 can be found on Page 1 of the form under Line 1a.';
        this.activeBtn = 7;
        break;
      case 8:
        this.helpImageSrc = '../../../../../assets/incomeHelpImages/1120/profit_before_taxes.png';
        this.helpInstruction = 'Profit before Taxes on the Federal Tax Return Form 1120 can be found on Page 1 of the form under Line 28.';
        this.activeBtn = 8;
        break;
      case 9:
        this.helpImageSrc = '../../../../../assets/incomeHelpImages/1120/interest.png';
        this.helpInstruction = 'Interest on the Federal Tax Return Form 1120 can be found on Page 1 of the form under Line 18.';
        this.activeBtn = 9;
        break;
      case 10:
        this.helpImageSrc = '../../../../../assets/incomeHelpImages/1120/depreciation.png';
        this.helpInstruction = 'Depreciation on the Federal Tax Return Form 1120 can be found on Page 1 of the form under Line 20.';
        this.activeBtn = 10;
        break;
      case 11:
        this.helpImageSrc = '../../../../../assets/incomeHelpImages/1120/amortization.png';
        this.helpInstruction = 'Amortization on the Federal Tax Return Form 1120 can be found in a separate Statement. It should be included in its listed expenses.';
        this.activeBtn = 11;
        break;
      case 12:
        this.helpImageSrc = '../../../../../assets/incomeHelpImages/1120/owners_comp.png';
        this.helpInstruction = 'All Owner(s)’s Compensation on the Federal Tax Return Form 1120 can be found on Page 1 of the form under Line 12.';
        this.activeBtn = 12;
        break;

      // 1065
      case 13:
        this.helpImageSrc = '../../../../../assets/incomeHelpImages/1065/revenue.png';
        this.helpInstruction = 'Revenue on the Federal Tax Return Form 1065 can be found on Page 1 of the form under Line 1a.';
        this.activeBtn = 13;
        break;
      case 14:
        this.helpImageSrc = '../../../../../assets/incomeHelpImages/1065/profit_before_taxes.png';
        this.helpInstruction = 'Profit before Taxes on the Federal Tax Return Form 1065 can be found on Page 1 of the form under Line 22.';
        this.activeBtn = 14;
        break;
      case 15:
        this.helpImageSrc = '../../../../../assets/incomeHelpImages/1065/interest.png';
        this.helpInstruction = 'Interest on the Federal Tax Return Form 1065 can be found on Page 1 of the form under Line 15.';
        this.activeBtn = 15;
        break;
      case 16:
        this.helpImageSrc = '../../../../../assets/incomeHelpImages/1065/depreciation.png';
        this.helpInstruction = 'Depreciation on the Federal Tax Return Form 1065 can be found on Page 1 of the form under Line 16a.';
        this.activeBtn = 16;
        break;
      case 17:
        this.helpImageSrc = '../../../../../assets/incomeHelpImages/1065/amortization.png';
        this.helpInstruction = 'Amortization on the Federal Tax Return Form 1065 can be found in a separate Statement. It should be included in its listed expenses.';
        this.activeBtn = 17;
        break;
      case 18:
        this.helpImageSrc = '../../../../../assets/incomeHelpImages/1065/owners_comp.png';
        this.helpInstruction = 'All Owner(s)’s Compensation on the Federal Tax Return Form 1065 can be found on Page 1 of the form under Line 9.';
        this.activeBtn = 18;
        break;
      case 19:
        this.helpImageSrc = '../../../../../assets/incomeHelpImages/1065/guaranteed_payments.png';
        this.helpInstruction = 'Guaranteed Payments to Partners on the Federal Tax Return Form 1065 can be found on Page 1 of the form under Line 10.';
        this.activeBtn = 19;
        break;

      // 1040
      case 20:
        this.helpImageSrc = '../../../../../assets/incomeHelpImages/1040/revenue.png';
        this.helpInstruction = 'Revenue on the Schedule C can be found on Page 1 of the form under Part I, Line 1.';
        this.activeBtn = 20;
        break;
      case 21:
        this.helpImageSrc = '../../../../../assets/incomeHelpImages/1040/profit_before_taxes.png';
        this.helpInstruction = 'Profit before Taxes on the Schedule C can be found on Page 1 of the form under Part II, Line 29.';
        this.activeBtn = 21;
        break;
      case 22:
        this.helpImageSrc = '../../../../../assets/incomeHelpImages/1040/interest.png';
        this.helpInstruction = 'Interest on the Schedule C can be found on Page 1 of the form under Part II, Line 16.';
        this.activeBtn = 22;
        break;
      case 23:
        this.helpImageSrc = '../../../../../assets/incomeHelpImages/1040/depreciation.png';
        this.helpInstruction = 'Depreciation on the Schedule C can be found on Page 1 of the form under Part II, Line 13.';
        this.activeBtn = 23;
        break;
      case 24:
        this.helpImageSrc = '../../../../../assets/incomeHelpImages/1040/amortization.png';
        this.helpInstruction = 'Amortization on the Schedule C can be found in Part V (“Other Expenses”) of the form. It should be included in its listed expenses. If it is not included here, it may be on a separate Statement.';
        this.activeBtn = 24;
        break;
      case 25:
        this.helpImageSrc = '../../../../../assets/incomeHelpImages/1040/owners_comp.png';
        this.helpInstruction = 'All Owner(s)’s Compensation on the Schedule C can be found on Page 1 of the form under Part II, Line 26';
        this.activeBtn = 25;
        break;

      // CPA
      case 26:
        this.helpImageSrc = '../../../../../assets/incomeHelpImages/CPA/revenue.png';
        this.helpInstruction = 'Revenue on most Internally-prepared financial documents will be under the Profit and Loss heading and read as “Total Income”.';
        this.activeBtn = 26;
        break;
      case 27:
        this.helpImageSrc = '../../../../../assets/incomeHelpImages/CPA/profit_before_taxes.png';
        this.helpInstruction = 'Profit before Taxes on most Internally-prepared financial documents will be under the Profit and Loss heading.';
        this.activeBtn = 27;
        break;
      case 28:
        this.helpImageSrc = '../../../../../assets/incomeHelpImages/CPA/interest.png';
        this.helpInstruction = 'Interest on most Internally-prepared financial documents will be itemized under the Profit and Loss heading under “Expenses”.';
        this.activeBtn = 28;
        break;
      case 29:
        this.helpImageSrc = '../../../../../assets/incomeHelpImages/CPA/depreciation.png';
        this.helpInstruction = 'Depreciation on most Internally-prepared financial documents will be itemized under the Profit and Loss heading under “Expenses”.';
        this.activeBtn = 29;
        break;
      case 30:
        this.helpImageSrc = '../../../../../assets/incomeHelpImages/CPA/amortization.png';
        this.helpInstruction = 'Amortization on most Internally-prepared financial documents will be itemized under the Profit and Loss heading under “Expenses”.';
        this.activeBtn = 30;
        break;
      case 31:
        this.helpImageSrc = '../../../../../assets/incomeHelpImages/CPA/owners_comp.png';
        this.helpInstruction = 'All Owner(s)’s Compensation on most Internally-prepared financial documents will be itemized under the Profit and Loss heading under “Expenses”.';
        this.activeBtn = 31;
        break;
      default:
        this.helpImageSrc = '';
        this.helpInstruction = '';
        this.activeBtn = 0;
        break;
    }
  }

  cancel() {
    this.bsModalRef.hide();
  }

}
